import React from "react";
import { FlowOverviewFormStep } from "./FlowOverviewFormStep";
import { FlowConnectionStep } from "./FlowConnectionsStep";
import { type AssetCreateModeType } from "#src/batteries-included-components/Buttons/CreateAssetDropdownMenu/CreateAssetDropdownMenu";
import { type StorageKeys } from "@validereinc/common-components";
import { FlowDetailsFormStep } from "./FlowDetailsFormStep";

export const FlowFormPanel = ({
  isConnectionEditOnly,
  flowId,
  filterConfigStorageKey,
  assetCreateMode,
  shouldUseAssetBuilder,
}: {
  isConnectionEditOnly?: boolean;
  flowId: string;
  shouldUseAssetBuilder?: boolean;
  assetCreateMode?: AssetCreateModeType;
} & Pick<StorageKeys, "filterConfigStorageKey">) => {
  if (isConnectionEditOnly) {
    return (
      <FlowConnectionStep
        flowId={flowId}
        stepNumberOverride={1}
      />
    );
  }

  return (
    <>
      <FlowOverviewFormStep
        flowId={flowId}
        filterConfigStorageKey={filterConfigStorageKey}
        assetCreateMode={assetCreateMode}
        shouldUseAssetBuilder={shouldUseAssetBuilder}
      />
      <FlowDetailsFormStep />
      {!shouldUseAssetBuilder ? <FlowConnectionStep flowId={flowId} /> : null}
    </>
  );
};
